<template>
  <van-popup v-model="showDateSelect" position="bottom" get-container="body" @closed="onClosed">
    <van-datetime-picker
      v-model="dateSelect"
      type="date"
      :max-date="maxSelectDate"
      :min-date="minSelectDate"
      :formatter="formatter"
      @confirm="onDateConfirm"
      @cancel="onDateCancel"
    />
  </van-popup>

</template>
<script>
import { DatetimePicker, Popup } from 'vant'
import { formatDate } from '@/utils/base'
export default {
  components: {
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup
  },
  props: {
    // eslint-disable-next-line
    minDate:undefined,
    // eslint-disable-next-line
    maxDate:undefined,
    // eslint-disable-next-line
    defaultDate:undefined,
    // eslint-disable-next-line
    value: Boolean,
  },
  data() {
    return {
      showDateSelect: false,
      dateSelect: new Date(1990, 1, 1),
      minSelectDate: new Date(1900, 1, 1),
      maxSelectDate: new Date()
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.showDateSelect = true
      }
    },
    defaultDate(newValue) {
      console.log('监听到了defaultDate', newValue)
      if (newValue) {
        this.dateSelect = new Date(newValue)// newValue
      }
    },
    minDate(newValue) {
      this.minSelectDate = newValue
      console.log('minSelectDate', newValue)
    },
    maxDate(newValue) {
      this.maxSelectDate = newValue
      console.log('maxSelectDate', newValue)
    }
  },
  created() {
    this.list = this.typelist
  },
  methods: {
    onDateConfirm() {
      console.log('onDateConfirm')
      this.showDateSelect = false
      this.$emit('onChange', formatDate(this.dateSelect, 'yyyy/MM/dd'))
    },
    onDateCancel() {
      console.log('onDateCancel')
      this.showDateSelect = false
      this.dateSelect = ''
      this.$emit('onChange', '')
    },
    onClosed() {
      this.$emit('input', false)
    },
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      }
      return value
    }
  }
}
</script>

